import { atom } from 'jotai';

/**
 * 화면이 알린 소유 여부. 좌측 메뉴와 목록 버튼이 읽는다.
 * - `undefined`: 선언한 화면 없음 / `isMine: null`: 아직 모름 — 아무 메뉴도 고르지 않는다
 * `owner` 는 선언한 쪽 표식이다. 정리는 내 값일 때만 한다.
 */
export const ownershipAtom = atom<
  { owner: symbol; isMine: boolean | null } | undefined
>(undefined);
